export default __webpack_public_path__ + "static/media/ci-antigua-ejemplo-back.1ffd99f3.png";